<div class="card">
    <div class="card-body">
        <div class="d-flex align-items-center mb-4">
            <button type="button" class="bill-service__back-icon me-2" (click)="goBack()" aria-label="Regresar">
                <i class="ti ti-arrow-left"></i>
            </button>
            <h4 class="mb-0">Crear factura</h4>
        </div>

        <!-- 1 · Datos fiscales del cliente -->
        <div class="bill-service__step d-flex align-items-center">
            <span class="bill-service__step-circle">1</span>
            <span class="bill-service__step-label">Datos fiscales del cliente</span>
        </div>
        <div class="bill-service__fiscal-card mt-3">
            <div class="row g-3">
                <div class="col-md-6">
                    <label class="bill-service__field-label">Cliente</label>
                    <div class="bill-service__custom-select" [class.is-open]="clientOpen">
                        <button type="button" class="bill-service__custom-select-trigger" (click)="toggleClient()">
                            <span class="bill-service__custom-select-value" *ngIf="selectedClient; else phClient">
                                <span class="bill-service__code-chip">{{ selectedClient.rfc }}</span>
                                <span>{{ selectedClient.name }}</span>
                            </span>
                            <ng-template #phClient>
                                <span class="bill-service__custom-select-placeholder">Seleccionar</span>
                            </ng-template>
                            <i class="ti ti-chevron-down bill-service__custom-select-caret"></i>
                        </button>
                        <div class="bill-service__custom-select-menu bill-service__invoice-menu"
                             *ngIf="clientOpen" (click)="$event.stopPropagation()">
                            <div class="bill-service__invoice-search">
                                <i class="ti ti-search bill-service__invoice-search-icon"></i>
                                <input type="text" class="bill-service__invoice-search-input"
                                       [(ngModel)]="clientSearchText"
                                       placeholder="Buscar por razón social o RFC..." autocomplete="off">
                            </div>
                            <div class="bill-service__invoice-list">
                                <div *ngIf="filteredClients.length === 0" class="bill-service__custom-select-option text-muted">
                                    Sin clientes
                                </div>
                                <div *ngFor="let client of filteredClients"
                                     class="bill-service__custom-select-option" (click)="selectClient(client)">
                                    <span class="bill-service__code-chip">{{ client.rfc }}</span>
                                    <span>{{ client.name }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Se autollenan desde el cliente: son los datos de su Constancia
                 de Situación Fiscal, no se capturan aquí. -->
            <div class="row g-3 mt-1">
                <div class="col-md-6">
                    <label class="bill-service__field-label">RFC</label>
                    <input type="text" class="form-control" readonly
                           placeholder="Selecciona un cliente" [value]="selectedClient?.rfc || ''">
                </div>
                <div class="col-md-6">
                    <label class="bill-service__field-label">Régimen fiscal</label>
                    <input type="text" class="form-control" readonly
                           placeholder="Selecciona un cliente"
                           [value]="selectedClient ? selectedClient.fiscalRegimeKey + ' · ' + selectedClient.fiscalRegimeName : ''">
                </div>
                <div class="col-md-6">
                    <label class="bill-service__field-label">Razón social</label>
                    <input type="text" class="form-control" readonly
                           placeholder="Selecciona un cliente" [value]="selectedClient?.businessName || ''">
                </div>
                <div class="col-md-6">
                    <label class="bill-service__field-label">Código postal (Domicilio fiscal)</label>
                    <input type="text" class="form-control" readonly
                           placeholder="Selecciona un cliente" [value]="selectedClient?.postalCode || ''">
                </div>
                <div class="col-12">
                    <label class="bill-service__field-label">Domicilio fiscal</label>
                    <input type="text" class="form-control" readonly
                           placeholder="Selecciona un cliente" [value]="selectedClient?.address || ''">
                </div>
                <div class="col-md-6">
                    <label class="bill-service__field-label">Correo electrónico (Opcional)</label>
                    <input type="text" class="form-control" readonly
                           placeholder="Selecciona un cliente" [value]="selectedClient?.email || ''">
                </div>
                <div class="col-md-6">
                    <label class="bill-service__field-label">Uso de CFDI</label>
                    <input type="text" class="form-control" readonly
                           placeholder="Selecciona un cliente"
                           [value]="selectedClient ? selectedClient.cfdiUseKey + ' · ' + selectedClient.cfdiUseName : ''">
                </div>
            </div>
        </div>

        <!-- 2 · Servicios a facturar -->
        <div class="bill-service__step d-flex align-items-center mt-4">
            <span class="bill-service__step-circle">2</span>
            <span class="bill-service__step-label">Servicios a facturar</span>
        </div>
        <div class="bill-service__fiscal-card mt-3">
            <label class="bill-service__field-label">Asociar servicios sin facturar</label>
            <div class="bill-service__custom-select" [class.is-open]="servicesOpen">
                <button type="button" class="bill-service__custom-select-trigger" (click)="toggleServices()">
                    <span class="bill-service__custom-select-value" *ngIf="serviceLines.length > 0; else phServices">
                        <span>{{ serviceLines.length }} servicio{{ serviceLines.length === 1 ? '' : 's' }} seleccionado{{ serviceLines.length === 1 ? '' : 's' }}</span>
                    </span>
                    <ng-template #phServices>
                        <span class="bill-service__custom-select-placeholder">Selecciona servicios</span>
                    </ng-template>
                    <i class="ti ti-chevron-down bill-service__custom-select-caret"></i>
                </button>

                <div class="bill-service__custom-select-menu bill-service__invoice-menu"
                     *ngIf="servicesOpen" (click)="$event.stopPropagation()">
                    <div class="bill-service__invoice-search">
                        <i class="ti ti-search bill-service__invoice-search-icon"></i>
                        <input type="text" class="bill-service__invoice-search-input"
                               [(ngModel)]="serviceSearch" (input)="onServiceSearch()"
                               placeholder="Folio, cliente..." autocomplete="off">
                    </div>
                    <div class="bill-service__invoice-list">
                        <div *ngIf="loadingServices" class="bill-service__custom-select-option text-muted">Cargando…</div>
                        <div *ngIf="!loadingServices && pendingServices.length === 0"
                             class="bill-service__custom-select-option text-muted">
                            Sin servicios de almacén pendientes de facturar
                        </div>
                        <label *ngFor="let service of pendingServices"
                               class="bill-service__invoice-option"
                               [class.is-selected]="isServiceSelected(service.id)">
                            <input type="checkbox" class="bill-service__invoice-checkbox"
                                   [checked]="isServiceSelected(service.id)"
                                   (change)="toggleServiceSelection(service)">
                            <span class="bill-service__code-chip">{{ service.folio }}</span>
                            <span class="bill-service__invoice-option-text">
                                {{ service.clientName }} · {{ service.concept }}
                                <small class="text-muted d-block">
                                    {{ service.warehouse }} · {{ service.servedAt }} ·
                                    {{ service.quantity }} × {{ formatCurrency(service.unitPrice) }}
                                </small>
                            </span>
                        </label>
                    </div>
                    <div class="bill-service__invoice-confirm">
                        <button type="button" class="bill-service__invoice-confirm-btn" (click)="toggleServices()">
                            <i class="ti ti-check"></i> Listo
                            <span *ngIf="serviceLines.length > 0">({{ serviceLines.length }})</span>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Un concepto CFDI por servicio asociado, editable antes de timbrar. -->
            <div class="table-responsive mt-3" *ngIf="serviceLines.length > 0">
                <table class="table table-sm align-middle warehouse-new__lines">
                    <thead>
                        <tr>
                            <th>SERVICIO</th>
                            <th style="min-width: 180px;">DESCRIPCIÓN</th>
                            <th>CANT.</th>
                            <th>UNIDAD</th>
                            <th>P. UNITARIO</th>
                            <th>CLAVE SAT</th>
                            <th>IMPUESTO</th>
                            <th class="text-end">IMPORTE</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let line of serviceLines">
                            <td>
                                <span class="bill-service__code-chip">{{ line.folio }}</span>
                                <div class="small text-muted">{{ line.warehouse }}</div>
                            </td>
                            <td>
                                <input type="text" class="form-control form-control-sm"
                                       [(ngModel)]="line.description" maxlength="900">
                            </td>
                            <td>
                                <input type="number" min="0" step="1" class="form-control form-control-sm"
                                       style="width: 90px;" [(ngModel)]="line.quantity">
                            </td>
                            <td>
                                <select class="form-select form-select-sm" [(ngModel)]="line.unitKey">
                                    <option *ngFor="let unit of units" [value]="unit.key">{{ unit.key }} · {{ unit.name }}</option>
                                </select>
                            </td>
                            <td>
                                <input type="number" min="0" step="0.01" class="form-control form-control-sm"
                                       style="width: 110px;" [(ngModel)]="line.unitPrice">
                            </td>
                            <td>
                                <select class="form-select form-select-sm" [(ngModel)]="line.productServiceKey">
                                    <option *ngFor="let key of productServiceKeys" [value]="key.key">{{ key.key }}</option>
                                </select>
                            </td>
                            <td>
                                <select class="form-select form-select-sm" [(ngModel)]="line.taxObjectKey">
                                    <option *ngFor="let option of taxObjectOptions" [value]="option.key">
                                        {{ option.key }} · {{ option.name }}
                                    </option>
                                </select>
                            </td>
                            <td class="text-end">{{ formatCurrency(serviceAmount(line)) }}</td>
                            <td>
                                <button type="button" class="bill-service__upload-remove"
                                        (click)="removeServiceLine(line.serviceId)" aria-label="Quitar servicio">
                                    <i class="ti ti-x"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Totales de la factura completa: servicios asociados más los
                 insumos del paso 4, que es lo que se acaba timbrando. -->
            <div class="bill-service__summary-panel mt-3" *ngIf="serviceLines.length > 0 || filledSupplyLines.length > 0">
                <div class="bill-service__summary-row">
                    <span class="bill-service__summary-label">Subtotal</span>
                    <span class="bill-service__summary-total">{{ formatCurrency(subtotal) }}</span>
                </div>
                <div class="bill-service__summary-row">
                    <span class="bill-service__summary-label">IVA (16%)</span>
                    <span class="bill-service__summary-total">{{ formatCurrency(iva) }}</span>
                </div>
                <div class="bill-service__summary-divider"></div>
                <div class="bill-service__summary-row bill-service__summary-row--balance">
                    <span class="bill-service__summary-label">Total</span>
                    <span class="bill-service__summary-balance">{{ formatCurrency(total) }}</span>
                </div>
            </div>
        </div>

        <!-- 3 · Configuración CFDI -->
        <div class="bill-service__step d-flex align-items-center mt-4">
            <span class="bill-service__step-circle">3</span>
            <span class="bill-service__step-label">Configuración CFDI</span>
        </div>
        <div class="bill-service__fiscal-card mt-3">
            <div class="row g-3">
                <div class="col-md-6">
                    <label class="bill-service__field-label">Forma de pago</label>
                    <div class="bill-service__custom-select" [class.is-open]="paymentFormOpen">
                        <button type="button" class="bill-service__custom-select-trigger"
                                (click)="togglePaymentForm()" [disabled]="isPaymentFormLocked">
                            <span class="bill-service__custom-select-value" *ngIf="selectedPaymentForm; else phForm">
                                <span class="bill-service__code-chip">{{ selectedPaymentForm.key }}</span>
                                <span>{{ selectedPaymentForm.name }}</span>
                            </span>
                            <ng-template #phForm>
                                <span class="bill-service__custom-select-placeholder">Seleccionar</span>
                            </ng-template>
                            <i class="ti ti-chevron-down bill-service__custom-select-caret"></i>
                        </button>
                        <ul class="bill-service__custom-select-menu" *ngIf="paymentFormOpen">
                            <li *ngFor="let form of paymentForms" class="bill-service__custom-select-option"
                                (click)="selectPaymentForm(form.key)">
                                <span class="bill-service__code-chip">{{ form.key }}</span>
                                <span>{{ form.name }}</span>
                            </li>
                        </ul>
                    </div>
                    <small class="text-muted" *ngIf="isPaymentFormLocked">
                        Con método PPD la forma de pago debe ser 99 (Por definir).
                    </small>
                </div>
                <div class="col-md-6">
                    <label class="bill-service__field-label">Método de pago</label>
                    <div class="bill-service__custom-select" [class.is-open]="paymentMethodOpen">
                        <button type="button" class="bill-service__custom-select-trigger" (click)="togglePaymentMethod()">
                            <span class="bill-service__custom-select-value" *ngIf="selectedPaymentMethod; else phMethod">
                                <span class="bill-service__code-chip">{{ selectedPaymentMethod.key }}</span>
                                <span>{{ selectedPaymentMethod.name }}</span>
                            </span>
                            <ng-template #phMethod>
                                <span class="bill-service__custom-select-placeholder">Seleccionar</span>
                            </ng-template>
                            <i class="ti ti-chevron-down bill-service__custom-select-caret"></i>
                        </button>
                        <ul class="bill-service__custom-select-menu" *ngIf="paymentMethodOpen">
                            <li *ngFor="let method of paymentMethods" class="bill-service__custom-select-option"
                                (click)="selectPaymentMethod(method.key)">
                                <span class="bill-service__code-chip">{{ method.key }}</span>
                                <span>{{ method.name }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <!-- 4 · Concepto a facturar -->
        <div class="bill-service__step d-flex align-items-center mt-4">
            <span class="bill-service__step-circle">4</span>
            <span class="bill-service__step-label">Concepto a facturar</span>
        </div>
        <div class="bill-service__fiscal-card mt-3">
            <label class="bill-service__field-label">Clave de servicio/producto (SAT)</label>
            <div class="bill-service__custom-select" [class.is-open]="productServiceOpen">
                <button type="button" class="bill-service__custom-select-trigger" (click)="toggleProductService()">
                    <span class="bill-service__custom-select-value" *ngIf="selectedProductService; else phKey">
                        <span class="bill-service__code-chip">{{ selectedProductService.key }}</span>
                        <span>{{ selectedProductService.name }}</span>
                    </span>
                    <ng-template #phKey>
                        <span class="bill-service__custom-select-placeholder">Seleccionar</span>
                    </ng-template>
                    <i class="ti ti-chevron-down bill-service__custom-select-caret"></i>
                </button>
                <ul class="bill-service__custom-select-menu" *ngIf="productServiceOpen">
                    <li *ngFor="let key of productServiceKeys" class="bill-service__custom-select-option"
                        (click)="selectProductService(key.key)">
                        <span class="bill-service__code-chip">{{ key.key }}</span>
                        <span>{{ key.name }}</span>
                    </li>
                </ul>
            </div>

            <label class="bill-service__field-label mt-3">Descripción del servicio</label>
            <div class="bill-service__textarea-wrapper">
                <textarea class="form-control bill-service__textarea" rows="3"
                          [(ngModel)]="description" [maxlength]="descriptionMax"
                          placeholder="Ingresar"></textarea>
                <span class="bill-service__textarea-counter">{{ description.length }}/{{ descriptionMax }}</span>
            </div>

            <div class="warehouse-new__supply-row mt-3" *ngFor="let line of supplyLines; let i = index">
                <div class="warehouse-new__supply-field">
                    <label class="bill-service__field-label" *ngIf="i === 0">Insumos utilizados</label>
                    <div class="bill-service__custom-select" [class.is-open]="line.open">
                        <button type="button" class="bill-service__custom-select-trigger" (click)="toggleSupply(line)">
                            <span class="bill-service__custom-select-value" *ngIf="line.supply; else phSupply">
                                <span class="warehouse-new__supply-name">{{ line.supply }}</span>
                            </span>
                            <ng-template #phSupply>
                                <span class="bill-service__custom-select-placeholder">Seleccionar</span>
                            </ng-template>
                            <i class="ti ti-chevron-down bill-service__custom-select-caret"></i>
                        </button>
                        <ul class="bill-service__custom-select-menu" *ngIf="line.open">
                            <li *ngFor="let supply of supplies" class="bill-service__custom-select-option"
                                (click)="selectSupply(line, supply)">
                                <span>{{ supply.name }}</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="warehouse-new__supply-qty">
                    <label class="bill-service__field-label" *ngIf="i === 0">Cantidad</label>
                    <input type="number" min="0" step="1" class="form-control"
                           [(ngModel)]="line.quantity" placeholder="Ingresar">
                </div>

                <div class="warehouse-new__supply-price">
                    <label class="bill-service__field-label" *ngIf="i === 0">Precio unitario</label>
                    <input type="number" min="0" step="0.01" class="form-control"
                           [(ngModel)]="line.unitPrice" placeholder="$0.00">
                </div>

                <div class="warehouse-new__supply-action">
                    <label class="bill-service__field-label" *ngIf="i === 0">&nbsp;</label>
                    <button type="button" class="warehouse-new__add-btn" *ngIf="i === 0" (click)="addSupplyLine()">
                        <i class="ti ti-plus"></i>
                        Agregar más insumos
                    </button>
                    <button type="button" class="bill-service__upload-remove" *ngIf="i > 0"
                            (click)="removeSupplyLine(i)" aria-label="Quitar insumo">
                        <i class="ti ti-x"></i>
                    </button>
                </div>
            </div>

            <button type="button" class="warehouse-new__link mt-3" (click)="openSupplyModal()">
                <i class="ti ti-plus"></i>
                Registrar nuevo insumo
            </button>

            <div class="warehouse-new__tax mt-3">
                <label class="bill-service__field-label">¿El servicio es objeto de impuesto?</label>
                <div class="bill-service__custom-select" [class.is-open]="taxObjectOpen">
                    <button type="button" class="bill-service__custom-select-trigger" (click)="toggleTaxObject()">
                        <span class="bill-service__custom-select-value" *ngIf="selectedTaxObject; else phTax">
                            <span class="bill-service__code-chip">{{ selectedTaxObject.key }}</span>
                            <span>{{ selectedTaxObject.name }}</span>
                        </span>
                        <ng-template #phTax>
                            <span class="bill-service__custom-select-placeholder">Seleccionar</span>
                        </ng-template>
                        <i class="ti ti-chevron-down bill-service__custom-select-caret"></i>
                    </button>
                    <ul class="bill-service__custom-select-menu" *ngIf="taxObjectOpen">
                        <li *ngFor="let option of taxObjectOptions" class="bill-service__custom-select-option"
                            (click)="selectTaxObject(option.key)">
                            <span class="bill-service__code-chip">{{ option.key }}</span>
                            <span>{{ option.name }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <!-- 5 · Comprobante de pago -->
        <div class="bill-service__step d-flex align-items-center mt-4">
            <span class="bill-service__step-circle">5</span>
            <span class="bill-service__step-label">Comprobante de pago</span>
        </div>
        <div class="mt-3">
            <label class="bill-service__upload-link" for="warehouseReceipt">Subir comprobante</label>
            <input type="file" id="warehouseReceipt" class="d-none"
                   accept="image/*,application/pdf" (change)="onReceiptSelected($event)">

            <div class="bill-service__upload-files mt-3" *ngIf="receipt">
                <div class="bill-service__upload-item">
                    <img *ngIf="!receipt.isPdf && receipt.preview" [src]="receipt.preview"
                         class="bill-service__upload-thumb" alt="">
                    <span *ngIf="receipt.isPdf" class="bill-service__upload-pdf"><i class="ti ti-file-type-pdf"></i></span>
                    <span class="bill-service__upload-name">{{ receipt.name }}</span>
                    <button type="button" class="bill-service__upload-remove" (click)="removeReceipt()" aria-label="Quitar comprobante">
                        <i class="ti ti-x"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="bill-service__actions d-flex justify-content-center gap-3 mt-5">
            <button type="button" class="btn bill-service__btn-cancel" (click)="onCancel()" [disabled]="isGenerating">
                Cancelar
            </button>
            <button type="button" class="btn bill-service__btn-submit" (click)="onSubmit()"
                    [disabled]="!isFormValid || isGenerating">
                <span *ngIf="!isGenerating">Facturar</span>
                <span *ngIf="isGenerating"><i class="ti ti-loader bill-service__spin"></i> Facturando…</span>
            </button>
        </div>
    </div>
</div>

<!-- Modal de alta de insumo. Se pinta fuera de la tarjeta para que el fondo
     cubra la pantalla completa. -->
<div class="warehouse-modal" *ngIf="supplyModalOpen" (click)="closeSupplyModal()">
    <div class="warehouse-modal__dialog" (click)="$event.stopPropagation()" role="dialog" aria-modal="true"
         aria-labelledby="registrarInsumoTitulo">
        <h5 class="warehouse-modal__title" id="registrarInsumoTitulo">Registrar nuevo insumo</h5>
        <p class="warehouse-modal__subtitle">Completa los datos a continuación</p>

        <div class="row g-3">
            <div class="col-md-7">
                <label class="bill-service__field-label">Nombre del insumo</label>
                <input type="text" class="form-control" [(ngModel)]="newSupplyName"
                       (keydown.enter)="registerSupply()" placeholder="Ingresar nombre" autocomplete="off">
            </div>
            <div class="col-md-5">
                <label class="bill-service__field-label">Costo del insumo</label>
                <input type="number" min="0" step="0.01" class="form-control" [(ngModel)]="newSupplyCost"
                       (keydown.enter)="registerSupply()" placeholder="$0.00">
            </div>
        </div>

        <div class="warehouse-modal__actions">
            <button type="button" class="btn bill-service__btn-cancel warehouse-modal__btn"
                    (click)="closeSupplyModal()">Cancelar</button>
            <button type="button" class="btn bill-service__btn-submit warehouse-modal__btn"
                    (click)="registerSupply()" [disabled]="!canRegisterSupply">
                Registrar insumo
                <i class="ti ti-arrow-right ms-2"></i>
            </button>
        </div>
    </div>
</div>
